<app-protected-information *ngIf="this.configurationService.application.enablePrivacyAct"></app-protected-information>


<form #form="ngForm" (ngSubmit)="form.form.valid && onSubmit()" novalidate>
  <div class="row justify-content-md-center mb-3">
    <div class="col-12 col-md-6">
      <div class="row">
        <label class="align-content-center">{{ "onboarding.selfie.title-with-id" | translate: {Default:"Selfie"} }}</label>
      </div>

      <div class="card justify-content-center mb-2 p-0" style="border-color: var(--info); border-radius: 15px">
        <div class="row no-gutters">
          <div class="col-2 col-sm-1 d-flex justify-content-center align-items-center p-0 m-0">
            <i class="fa fa-lg text-info fa-info-circle"></i>
          </div>
          <div class="col-10 col-sm-11 d-flex justify-content-center align-items-center p-0 m-0">
            <div class="card-body p-0">
              <p *ngIf="this.isAmericanCitizen(this.application)" class="card-text responsive-small text-info" style="font-size: 15px">
                {{ "onboarding.selfie.info" | translate: {Default:"En esta fotografía es necesario que se vea claramente tu rostro."} }}
              </p>
              <p *ngIf="!this.isAmericanCitizen(this.application)" class="card-text responsive-small text-info" style="font-size: 15px">
                {{ "onboarding.selfie.info-with-id" | translate: {Default:"En esta fotografía es necesario que se vea claramente tu rostro, así como la identificación que capturaste anteriormente para poder validar tu identidad."} }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="input-group mb-2 justify-content-center">
        <div class="row no-gutters">
          <div class="text-center">
            <i *ngIf="!hasSelfie" class="fas fa-exclamation-circle"></i>
            <i *ngIf="hasSelfie" class="fas fa-check-circle text-success"></i>
            <span>{{ "onboarding.selfie.added" | translate: {Default: "  Documento agregado"} }}</span>
            <br>
          </div>
        </div>
      </div>
      <div class="input-group mb-2 justify-content-center">

        <div *ngIf="this.configuration.enableSelfieDocuments" class="custom-file col-6">
          <input type="file" [class]="this.lang == 'es' ? 'custom-file-input-spanish' : 'custom-file-input-english'" id="selfie" name="selfie" aria-describedby="inputGroupFileAddon01" accept="image/png, image/jpeg, application/pdf" [(ngModel)]="selfieFileValue" #selfie='ngModel' (change)="changeFile($event.target)" [ngClass]="inputFieldCss(selfie, form)">
          <label *ngIf="application.uploadedSelfie" class="custom-file-label" for="selfie">{{application.selfie.name}}</label>
          <label *ngIf="!application.uploadedSelfie" class="custom-file-label" for="selfie"></label>
        </div>

        <!-- <div class="mt-1 col-6 text-center">
            <button class="btn btn-secondary" type="button" (click)="openInfoModal(modalInfoSelfie)">
            <i class="fas fa-camera"></i><span>{{ "onboarding.photos.camera_takePhoto" | translate: {Default:" Tomar Foto"} }}</span>
          </button>
        </div> -->

        <div class="grid-img">
          <img height="120" src="assets/images/onboarding/selfie.png"/>
          <button class="btn btn-secondary" type="button" (click)="openInfoModal(modalInfoSelfie)">
            <i class="fas fa-camera"></i><span>{{ "onboarding.photos.camera_takePhoto" | translate: {Default:" Tomar Foto"} }}</span>
          </button>
        </div>

      </div>
      <div *ngIf="application.selfie != null && !application.uploadedSelfie" class="row justify-content-center">
        <div class="col-5 mb-2">
          <img src="{{application.selfie}}" class="img-thumbnail" alt="...">
        </div>
      </div>
      <div *ngIf="application.selfie != null && application.uploadedSelfie" class="row justify-content-center mt-1">
        <div class="col-12 text-center">
          <i class="fas fa-4x fa-file-upload"></i>
          <p class="wrap-text small" >{{ "onboarding.photos.fileUploaded" | translate: {Default:"Archivo cargado correctamente: "} }}{{application.selfie.name}}</p>
        </div>
      </div>
    </div>
  </div>


  <div class="col-12 mb-5">
    <button *ngIf="this.appStatus != eApplicationStatusType.BLACK_LIST_DOCUMENTS" class="btn btn-secondary" type="button" (click)="onBack()">{{ "onboarding.personal-data.back" | translate: {Default:"Regresar"} }}</button>
    <button class="btn btn-primary float-right" [disabled]="!this.hasSelfie || form.invalid || !cameraPerms">{{ "onboarding.photos.continue" | translate: {Default:"Continuar"} }}</button>
  </div>
</form>

<ng-template #modal_takePhoto let-modal>
  <div class="modal-body justify-content-center">
    <div class="wrapper" (window:resize)="onResize($event)">
      <webcam [imageQuality]="0.7" [trigger]="triggerObservable" [width]="innerWidth" (imageCapture)="handleImage($event)" [allowCameraSwitch]="true" [switchCamera]="nextWebcamObservable" (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"></webcam>
    </div>
  </div>
  <div class="modal-footer text-center">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-danger" (click)="modal.close()"><i class="fas fa-3x fa-times"></i></button>
      <button type="button" class="btn btn-outline-success" (click)="triggerSnapshot(modal)"><i class="fas fa-3x fa-camera"></i></button>
    </div>
  </div>
</ng-template>

<ng-template #modalInfoSelfie let-modal>
  <div class="wrap-info-selfie">

    <div class="modal-header justify-content-between">

      <div style="display: flex; align-items: center; gap: 10px;">
        <i class="fa fa-lg text-warning fa-exclamation-triangle"></i>
        <h4 class="modal-title" id="modal-basic-title">{{ "onboarding.selfie-modal.header" | translate: {Default:"Importante"} }}</h4>
      </div>

      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <section>
      <article>
        <p>{{ "onboarding.selfie-modal.title-info" | translate: {Default:"Toma una foto de tu rostro con tu identificación."} }}</p>
        <div>
          <img height="120" src="assets/images/onboarding/selfie_correct.png"/>
        </div>
      </article>
      <article>
        <p>{{ "onboarding.selfie-modal.subtitle-info" | translate: {Default:"Opciones no válidas:"} }}</p>
        <div class="img-grid">
          <img height="120" src="assets/images/onboarding/selfie_incorrect_1.png"/>
          <img height="120" src="assets/images/onboarding/selfie_incorrect_2.png"/>
          <img height="120" src="assets/images/onboarding/selfie_incorrect_3.png"/>
          <img height="120" src="assets/images/onboarding/selfie_incorrect_4.png"/>
        </div>
      </article>
    </section>

    <h4 class="text-danger">{{ "onboarding.selfie-modal.warning-info" | translate: {Default:"Evita que tu registro sea rechazado."} }}</h4>

    <div class="foot-btn">
      <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="openPhotoModal(modal_takePhoto); modal.dismiss('Cross click')">{{ "accounts.modal_portals.accept" | translate: {Default:"Aceptar"} }}</button>      
    </div>

  </div>
</ng-template>